import React from "react";
import PropTypes from "prop-types";
import { ListGroup, ListGroupItem } from "reactstrap";
import { formatMoney } from "accounting";

const DiscountList = ({ discounts, children }) => (
  <ListGroup flush>
    {discounts.map((discount, index) => (
      <ListGroupItem className="discount-list" key={discount.id || index}>
        <div className="row justify-content-between align-items-center">
          <div className="col-md-10 col-sm-12">
            <div className="row">
              <div className="col-12  discount-item total">
                <p className="label pr-2 mb-0">{discount.description}</p>
                <label className="total">{`${formatMoney(
                  discount.quantity,
                  discount.discount_type === "flat" ? "$" : ""
                )}${discount.discount_type === "percent" ? "%" : ""}`}</label>
              </div>
            </div>
          </div>
          {typeof children === "function" && (
            <div className="col-md-2 col-sm-12">{children({ discount })}</div>
          )}
        </div>
      </ListGroupItem>
    ))}
  </ListGroup>
);

DiscountList.propTypes = {
  discounts: PropTypes.array.isRequired,
  contract: PropTypes.object.isRequired,
  updateDiscount: PropTypes.func.isRequired
};

export default DiscountList;
